{
  "el": {
    "modal": {
      "actions": {
        "add": "Ανάθεση αυτού του πελάτη σε αυτό το ακίνητο",
        "approve": "Έγκριση",
        "assign": "Ανάθεση σε αυτό το ακίνητο",
        "assign_SUP": "Ανάθεση σε αυτό το έργο",
        "block": "Αποκλεισμός",
        "cancel": "Ακύρωση",
        "close": "Κλείσιμο",
        "contact_ziggu": "Επικοινωνία με τη Ziggu",
        "deactivate": "Απενεργοποίηση",
        "giveAccess": "Παραχώρηση διαδικτυακής πρόσβασης",
        "goBack": "Επιστροφή",
        "gotIt": "Το κατάλαβα",
        "loading": "Φόρτωση...",
        "next": "Επόμενο",
        "no": "Όχι",
        "reactivate": "Επανενεργοποίηση",
        "remove": "Διαγραφή",
        "select_rights": "Επιλογή δικαιωμάτων",
        "send": "Αποστολή πρόσκλησης με email",
        "sendFeedback": "Αποστολή σχολίων",
        "skip": "Παράλειψη",
        "submit": "Υποβολή",
        "submitting": "Υποβολή...",
        "uploading": "Ανέβασμα...",
        "yes": "Ναι"
      },
      "labels": {
        "areYouSure": "Θέλεις σίγουρα να συνεχίσεις;",
        "areYouSureDelete": "Θέλεις σίγουρα να διαγράψεις {object};",
        "assignCustomerToUnitMessagePermanently": "{customer} έχει ήδη προσκληθεί στην πλατφόρμα. Με την ανάθεση αυτού του ακινήτου θα αποκτήσει άμεση πρόσβαση.",
        "assignCustomerToUnitTitlePermanently": "Μόνιμη ανάθεση {customer} σε {unit};",
        "assignTodoListToLevel": "Πρόκειται να αναθέσεις τη λίστα εργασιών {object} στο επίπεδο {level}. Θέλεις να συνεχίσεις;",
        "dangerZone": "Επικίνδυνη ζώνη",
        "deactivate": "Θέλεις σίγουρα να απενεργοποιήσεις {contact};",
        "deactivateMessage": "Ο χρήστης θα χάσει την πρόσβαση στην πλατφόρμα. Όλα τα έγγραφα, οι FAQ, οι ανακοινώσεις, οι εργασίες, οι συνομιλίες κ.λπ. που σχετίζονται με αυτόν τον χρήστη θα παραμείνουν διαθέσιμα στην πλατφόρμα για τους άλλους χρήστες.",
        "deleteCustomerMessage": "Αυτό το άτομο θα χάσει κάθε πρόσβαση στην πλατφόρμα και συνεπώς σε όλα τα έγγραφα, τις FAQ, τις συνομιλίες, τις ανακοινώσεις κ.λπ.",
        "deleteCustomerTitle": "Θέλεις σίγουρα να διαγράψεις τον πελάτη {customer};",
        "deleteDecisionsBulk": "Θέλεις σίγουρα να διαγράψεις {amount} αποφάσεις;",
        "deleteDeniedMessage": "Σε αυτόν τον πελάτη έχει ανατεθεί τουλάχιστον 1 ακίνητο. Αφαίρεσε πρώτα τα ανατεθειμένα ακίνητα και μετά διάγραψε τον πελάτη.",
        "deleteDeniedTitle": "Δεν επιτρέπεται η διαγραφή για {customer}",
        "deleteEmployeeIntercom": "Επικοινώνησε μαζί μας μέσω Intercom και θα σε βοηθήσουμε αμέσως.",
        "deleteEmployeeMessage": "Αυτός ο χρήστης θα χάσει κάθε πρόσβαση στην πλατφόρμα. Όλα τα έγγραφα, οι συνομιλίες και οι ανακοινώσεις που σχετίζονται με αυτόν τον χρήστη θα διαγραφούν επίσης.",
        "deleteEmployeeQuestion": "Διαγραφή αντ' αυτού;",
        "deleteEmployeeSubMessage": "Απενεργοποίησε αυτόν τον χρήστη αν θέλεις να διατηρήσεις όλες τις πληροφορίες του.",
        "deleteEmployeeTitle": "Θέλεις σίγουρα να διαγράψεις {employee};",
        "deleteLeadMessage": "Αν αυτό το lead ενδιαφερόταν για κάποιο ακίνητο, θα χάσεις αυτά τα δεδομένα. Αν το lead είχε αγοράσει ακίνητο και έγινε πελάτης, θα διατηρήσεις τον πελάτη και τα δεδομένα του.",
        "deleteLeadTitle": "Θέλεις σίγουρα να διαγράψεις το lead {lead};",
        "goToProposal": "Μετάβαση σε {proposal_name}",
        "gotItMessage": "Εντάξει, το κατάλαβα",
        "loading": "Το αρχείο ανεβαίνει, περίμενε λίγο. Η οθόνη ανεβάσματος θα κλείσει αυτόματα.",
        "noUnitSelected": "Δεν έχει επιλεγεί ακίνητο",
        "noUnitSelectedMessage": "Επίλεξε το ακίνητο για το οποίο θέλεις να αναφέρεις παρατήρηση",
        "notPossible": "Δεν είναι δυνατό",
        "ohNo": "Ωχ, όχι",
        "reactivate": "Θέλεις σίγουρα να επανενεργοποιήσεις {contact};",
        "reactivateMessage": "Ο χρήστης θα αποκτήσει ξανά πρόσβαση στην πλατφόρμα.",
        "removeCustomerDeleteInfo1": "Οι συνομιλίες στις οποίες συμμετείχε ο πελάτης θα διαγραφούν",
        "removeCustomerDeleteInfo2": "Τα ερωτηματολόγια που σχετίζονται με αυτό το ακίνητο θα διαγραφούν",
        "removeCustomerDeleteInfo3": "Τα έγγραφα που ανέβασε ο πελάτης μέσα σε συνομιλίες, αποφάσεις ή προτάσεις θα διαγραφούν. Αυτό περιλαμβάνει και τις υπογεγραμμένες εκδόσεις των εγγράφων.",
        "removeCustomerKeepInformation": "Τα γενικά έγγραφα και κάθε άλλο περιεχόμενο που έχει δημοσιευτεί σε αυτό το ακίνητο θα παραμείνουν αμετάβλητα και θα είναι ορατά σε νέο πελάτη.",
        "removeCustomerMessage": "{customer} είχε πλήρη πρόσβαση σε αυτό το ακίνητο. Αν αφαιρέσεις τον πελάτη, κάθε περιεχόμενο από {customer} θα διαγραφεί. Αυτό σημαίνει…",
        "removeCustomerMessageNth": "Αν αφαιρέσεις αυτόν τον πελάτη, το περιεχόμενο που δημιούργησε {customer} θα αποσυνδεθεί από {customer}. Το περιεχόμενο θα διατηρηθεί, αλλά δεν θα προέρχεται πλέον από {customer}.",
        "removeMessage": "Θέλεις σίγουρα να διαγράψεις {level}; Έτσι θα χάσεις όλα τα αποθηκευμένα δεδομένα που σχετίζονται με αυτό το {type} και δεν θα μπορείς να τα ανακτήσεις αργότερα.",
        "removeTitle": "Διαγραφή {record_name}",
        "revokeAccessMessage": "Πρόκειται να ανακαλέσεις την πρόσβαση που έχει {customer} σε αυτό το ακίνητο. Αν είναι το μοναδικό ακίνητο που του έχει ανατεθεί, θα χάσει εντελώς την πρόσβαση στην πλατφόρμα.",
        "setCustomerMessage": "Πρόκειται να αναθέσεις {customer} σε {unit}. {customer} δεν θα έχει ακόμη πλήρη πρόσβαση στην πλατφόρμα, αλλά μπορείς να το αλλάξεις παραχωρώντας πρόσβαση αφού αναθέσεις αυτό το ακίνητο.",
        "setCustomerMessageSUP": "Πρόκειται να αναθέσεις {customer} σε {unit}. {customer} δεν θα έχει ακόμη πλήρη πρόσβαση στην πλατφόρμα, αλλά μπορείς να το αλλάξεις παραχωρώντας πρόσβαση αφού αναθέσεις αυτό το έργο.",
        "setCustomerTitle": "Ανάθεση {customer} σε {unit};",
        "setVisibleMessage": "Πρόκειται να δώσεις σε {customer} πλήρη πρόσβαση στα κοινοποιημένα έγγραφα και στις πληροφορίες που σχετίζονται με {unit}.",
        "setVisibleTitle": "Να δοθεί σε {customer} διαδικτυακή πρόσβαση σε {unit};",
        "this": "αυτό",
        "typeHere": "Γράψε εδώ...",
        "typeToConfirm": "Γράψε «{confirmationInput}» για επιβεβαίωση",
        "warningAreYouSure": "Προσοχή. Θέλεις σίγουρα να συνεχίσεις;",
        "warningDeleteDocument": "Το {file_name} ανέβηκε σε {attachable_type}. Αν το αφαιρέσεις εδώ, θα αφαιρεθεί και από {attachable_type}",
        "warningDeleteDocumentApprovedProposal": "Το {file_name} είναι έγγραφο εγκεκριμένης πρότασης και δεν μπορεί να διαγραφεί σε αυτή την κατάσταση. Η διαγραφή του θα απαιτούσε ανάκληση της έγκρισης της πρότασης",
        "warningDeleteDocumentLevel": "Το {file_name} ανέβηκε στον φάκελο {level_type}. Αν το αφαιρέσεις εδώ, θα αφαιρεθεί και από τον φάκελο {level_type}",
        "warningDeleteDocumentMulti": "Ορισμένα από τα έγγραφα που θέλεις να διαγράψεις ανέβηκαν σε απόφαση ή σε συνομιλία. Αν τα αφαιρέσεις εδώ, θα αφαιρεθούν και από την απόφαση ή τη συνομιλία"
      }
    }
  }
}
